import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconLoudspeaker';
/** Renders an SVG icon. */
const SvgLoudspeaker = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="m9.934 24.276-.18 2.069.747.044zm15.41-7.371a1 1 0 0 1 1.366-.366l1.837 1.06a1 1 0 1 1-1 1.732l-1.837-1.06a1 1 0 0 1-.366-1.366m-6.197-8.474a32.2 32.2 0 0 1-7.719 5.98l-1.8.998 1.15 4.287 2.057-.035a32.2 32.2 0 0 1 9.675 1.319zm8.184 3.497a1 1 0 1 1 .518 1.932l-1.932.518a1 1 0 0 1-.518-1.932zM24.335 7.34a1 1 0 1 1 1.732 1l-1.061 1.838a1 1 0 1 1-1.732-1l1.06-1.838ZM12.432 25.872a2 2 0 0 1-2.052 2.514l-.746-.045a2 2 0 0 1-1.872-2.17l.341-3.914-.728.195A3 3 0 0 1 3.7 20.33l-.518-1.932a3 3 0 0 1 2.121-3.675l2.781-.745 2.372-1.317A30.2 30.2 0 0 0 18.49 6.19l.044-.046-.294-1.096a1 1 0 0 1 1.932-.518l5.177 19.319a1 1 0 0 1-1.932.517l-.294-1.097q-.03-.007-.061-.017a30.2 30.2 0 0 0-10.194-1.59l-1.557.026zm-6.8-6.059a1 1 0 0 0 1.225.707l1.932-.518-1.035-3.863-1.932.517a1 1 0 0 0-.707 1.225l.518 1.932Z"
      />
    </svg>
  );
};
SvgLoudspeaker.displayName = displayName;
export default SvgLoudspeaker;
